import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';

import { QuickSightDashboardComponent } from './quick-sight-dashboard.component';

@NgModule({
  declarations: [QuickSightDashboardComponent],
  imports: [CommonModule, FormsModule, RouterModule, ButtonModule, InputTextModule],
  exports: [QuickSightDashboardComponent],
})
export class QuickSightDashboardModule {}

